import request from '../request'
// 查询用户订单列表
export function getWycOrderList (params, loading) {
  return request({
    url: '/app/bookingCar/getOrderListByBill',
    method: 'get',
    params,
    loading
  })
}

export function getPtcOrderList (data, loading) {
  return request({
    url: '/app/group/order/query/invoiceList',
    method: 'post',
    data,
    loading
  })
}

// 抬头列表
export function lookList (params, loading) {
  return request({
    url: '/app/invoice/info/getList',
    method: 'get',
    params,
    loading
  })
}
// 添加抬头
export function insert (data, loading) {
  return request({
    url: '/app/invoice/info/insert',
    method: 'post',
    loading,
    data
  })
}

// 提交电子发票
export function applyInvoice (data, loading) {
  return request({
    url: '/app/invoice/applyInvoice',
    method: 'post',
    loading,
    data
  })
}

export function groupApplyInvoice (data, loading) {
  return request({
    url: '/app/group/order/applyInvoice',
    method: 'post',
    loading,
    data
  })
}

// 网约车开票记录
export function getWycInvoiceList (data, loading) {
  return request({
    url: '/app/invoice/selectInvoiceRecordListByUserId',
    method: 'post',
    loading,
    data
  })
}

// 拼团车开票记录
export function getPtcInvoiceList (data, loading) {
  return request({
    url: '/app/group/order/invoiceRecord',
    method: 'post',
    loading,
    data
  })
}

// 网约车开票详情
export function getWycInvoiceDetail (params, loading) {
  return request({
    url: '/app/invoice/getInvoiceRecordDetail',
    method: 'get',
    params,
    loading
  })
}
// 拼团车开票详情
export function getPtcInvoiceDetail (params, loading) {
  return request({
    url: '/app/group/order/recordDetail',
    method: 'get',
    params,
    loading
  })
}
// 发送已开具发票到邮箱
export function sendInvoiceToEmail (params, loading) {
  return request({
    url: '/app/invoice/sendInvoiceToEmail',
    method: 'get',
    params,
    loading
  })
}
// 获取发票抬头详情
export function getUpDetail (params, loading) {
  return request({
    url: '/app/invoice/info/getDetail',
    method: 'get',
    params,
    loading
  })
}
// 删除发票抬头
export function deleteUp (params, loading) {
  return request({
    url: '/app/invoice/info/delete',
    method: 'get',
    params,
    loading
  })
}
